import * as React from 'react';
import { MessageBoxFunctionalLayout, Text, Modal } from 'wix-style-react';
import { translate, InjectedTranslateProps } from 'react-i18next';
import { DataHooks } from '@src/constants/data-hooks';
import { withBIModalEvents, ModalProps } from '@src/components/with-bi-modal-events/with-bi-modal-events';
import { PopupType } from '@src/context/actions/bi';

type Props = ModalProps & InjectedTranslateProps & { isOpen: boolean };
const ResetLogPromptComponent = translate()(({ t, isOpen, onCancel, onOk, onClose }: Props) => (
  <Modal dataHook={DataHooks.ResetLogModal} isOpen={isOpen} onRequestClose={onClose} shouldCloseOnOverlayClick>
    <MessageBoxFunctionalLayout
      dataHook={DataHooks.ResetLogPrompt}
      confirmText={t('advanced-options.reset-log.prompt.ok')}
      onOk={onOk}
      cancelText={t('advanced-options.reset-log.prompt.cancel')}
      onCancel={onCancel}
      onClose={onClose}
      title={t('advanced-options.reset-log.prompt.title')}
      width="600px"
    >
      <Text>{t('advanced-options.reset-log.prompt.message')}</Text>
    </MessageBoxFunctionalLayout>
  </Modal>
));

export const ResetLogPrompt = withBIModalEvents(PopupType.ResetLog)(ResetLogPromptComponent);
